
import { useFormatMessage } from 'hooks';
import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import ClipLoader from 'react-spinners/ClipLoader';
import DealForm from 'components/DealForm';
import { createPromotion, fetchPromotion, modifyPromotion } from 'state/actions/promotion';
import './Deal.css';

const Deal = ({ history }) => {
  const { id, siteId, siteName } = useParams();

  const { success, promotionList, promotionData, sitesList, error } = useSelector(
    (state) => ({
      success: state.promotions.success,
      promotionList: state.promotions.list,
      promotionData: state.promotions.promotion,
      sitesList: state.sites.list,
      error: state.promotions.error,
    }),
    shallowEqual
  );

  const [deal, setDeal] = useState(promotionData || {});

  const dispatch = useDispatch();

  useEffect(() => {
    if (id) {
      const promotionFetched = promotionList.find(
        (fetchedPromotion) => fetchedPromotion._id === id
      );
      if (promotionFetched) {
        setDeal(promotionFetched);
      } else if (promotionData._id === id) {
        setDeal(promotionData);
      } else {
        dispatch(fetchPromotion(id));
      }
    }
  }, [id, promotionData]); // eslint-disable-line

  const isEditing = !!id;

  const dealForm =
    !deal && id ? (
      <ClipLoader />
    ) : (
      <DealForm
        isEditing={isEditing}
        deal={deal}
        sites={sitesList}
        setDeal={setDeal}
        action={isEditing ? modifyPromotion : createPromotion}
        success={success}
        id={id}
        history={history}
        error={error}
      />
    );

  // const redirect = (error || success) && <Redirect to={paths.USERS} />;

  const editDealMessage = useFormatMessage('Edit Promotion');

  const newDealMessage = useFormatMessage('Add New Promotion');

  return (
    <div className="media">
      <div className="media-header">
        <h1>{isEditing ? editDealMessage : newDealMessage}</h1>
        <Link
          to={`/${siteId}/information/${siteName}`}
          className="button-secondary"
        >
          <i className="feather-arrow-left" />
          Back
        </Link>
      </div>
      <div className="media-content">{dealForm}</div>
    </div>
  );
};

export default Deal;
